import { render, staticRenderFns } from "./SpecialUsers.vue?vue&type=template&id=f1cbabde&"
import script from "./SpecialUsers.vue?vue&type=script&lang=js&"
export * from "./SpecialUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports